/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DeleteOrderModal_order$ref: FragmentReference;
declare export opaque type DeleteOrderModal_order$fragmentType: DeleteOrderModal_order$ref;
export type DeleteOrderModal_order = {|
  +id: string,
  +orderNumber: string,
  +$refType: DeleteOrderModal_order$ref,
|};
export type DeleteOrderModal_order$data = DeleteOrderModal_order;
export type DeleteOrderModal_order$key = {
  +$data?: DeleteOrderModal_order$data,
  +$fragmentRefs: DeleteOrderModal_order$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "DeleteOrderModal_order",
  "type": "Order",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "orderNumber",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '88ba4bf8aeee0dee1eafcf0e1c08b72e';
module.exports = node;
